// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { TransportGetString, PlaybackConcurrencyModalGetString, PlaybackGetString, StageGetString, PlaybackRateTextButtonGetString, PlaybackRateMenuItemGetString, PlaybackControllerGetString, PlayIconButtonGetString, AutoplayModalGetString } from './types.generated'

const transportLocales = ['en-US'] as const

export const getStringTransport: TransportGetString = i18nBundle('transport', transportLocales).getString

const playbackConcurrencyModalLocales = ['en-US'] as const

export const getStringPlaybackConcurrencyModal: PlaybackConcurrencyModalGetString = i18nBundle('playbackConcurrencyModal', playbackConcurrencyModalLocales).getString

const playbackLocales = ['en-US'] as const

export const getString: PlaybackGetString = i18nBundle('playback', playbackLocales).getString
export const getStringPlayback: PlaybackGetString = getString

const stageLocales = ['en-US'] as const

export const getStringStage: StageGetString = i18nBundle('Stage', stageLocales).getString

const playbackRateTextButtonLocales = ['en-US'] as const

export const getStringPlaybackRateTextButton: PlaybackRateTextButtonGetString = i18nBundle('PlaybackRateTextButton', playbackRateTextButtonLocales).getString

const playbackRateMenuItemLocales = ['en-US'] as const

export const getStringPlaybackRateMenuItem: PlaybackRateMenuItemGetString = i18nBundle('PlaybackRateMenuItem', playbackRateMenuItemLocales).getString

const playbackControllerLocales = ['en-US'] as const

export const getStringPlaybackController: PlaybackControllerGetString = i18nBundle('PlaybackController', playbackControllerLocales).getString

const playIconButtonLocales = ['en-US'] as const

export const getStringPlayIconButton: PlayIconButtonGetString = i18nBundle('PlayIconButton', playIconButtonLocales).getString

const autoplayModalLocales = ['en-US'] as const

export const getStringAutoplayModal: AutoplayModalGetString = i18nBundle('AutoplayModal', autoplayModalLocales).getString

